import MuiButton from './MuiButton'

const overrides = {
  MuiButton
}

export default overrides
